import gql from 'graphql-tag';

import { onDemandAssignmentPresentationsFragments } from 'bundles/compound-assessments/components/api/onDemandAssignmentPresentationsQuery';

export default gql`
  query OnDemandAssignmentPresentationsExecutionQuery(
    $userId: String!
    $courseId: String!
    $itemId: String!
    $executionId: String
  ) {
    OnDemandAssignmentPresentationsV1 @naptime {
      forExecution(userId: $userId, courseId: $courseId, itemId: $itemId, executionId: $executionId) {
        elements {
          submissionStatus
          phases {
            ... on NaptimeOnDemandAssignmentPresentationsV1_phases_singleFormPhase {
              typeName
              definition {
                baseTaskId
                deadline

                task @type(name: "NaptimeOnDemandAssignmentPresentationsV1_Task") {
                  ...FormTaskFragment
                }
                fulfilled
              }
            }
            ... on NaptimeOnDemandAssignmentPresentationsV1_phases_reviewPhase {
              ...ReviewPhaseFragment
            }
          }
          teamId
          teamNeedsToBeAssigned
          assignmentVersionOutdated

          grade {
            ...GradeFragment
          }

          userId
          courseId
          itemId
        }
      }
    }
  }
  ${onDemandAssignmentPresentationsFragments}
`;
